// @flow

import React, { Fragment } from "react";
import { Grid, Thumbnail, Col, Row } from "react-bootstrap";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Gallery } from "../components/Gallery";
import Heading from "../components/Heading";

// export class Products extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       photoIndex: 0,
//       isOpen: false
//     };
//   }
//   render() {
//     const { isOpen, photoIndex } = this.state;

//     const images = [
//       "/arts-build.jpg",
//       "/city.jpg",
//       "/desk.jpeg",
//     ];

//     for (let index = 0; index < 40; index++) {
//       images.push(`/gallery/${(index+1).toString()}.jpg`)
//     }

//     const thumbnails = images.map((image, index) => {
//       return (
//         <Col key={image+index} xs={6} md={3}>
//           <Thumbnail href="#" alt="171x180" src={image} style={{ height: "100%" }} onClick={() => this.setState({ isOpen: true, photoIndex: index })} />
//         </Col>
//       );
//     });

//     const gallery = <Grid>{thumbnails}</Grid>;

//     return (
//       <Fragment>
//         <div style={{ width: "100%", height: "30px" }} />
//         {gallery}
//         {isOpen && (
//           <Lightbox
//             mainSrc={images[photoIndex]}
//             nextSrc={images[(photoIndex + 1) % images.length]}
//             prevSrc={images[(photoIndex + images.length - 1) % images.length]}
//             onCloseRequest={() => this.setState({ isOpen: false })}
//             onMovePrevRequest={() =>
//               this.setState({
//                 photoIndex: (photoIndex + images.length - 1) % images.length
//               })
//             }
//             onMoveNextRequest={() =>
//               this.setState({
//                 photoIndex: (photoIndex + 1) % images.length
//               })
//             }
//           />
//         )}
//       </Fragment>
//     );
//   }
// }

export class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }
  render() {
    const { isOpen, photoIndex } = this.state;

    const images = [
      // "/arts-build.jpg",
      // "/city.jpg",
      // "/desk.jpeg",
    ];

    for (let index = 0; index < 40; index++) {
      images.push(`/gallery/${(index+1).toString()}.jpg`)
    }

    return <Fragment><Heading /><Gallery images={images} /></Fragment>
  }
}



// WEBPACK FOOTER //
// ./src/pages/Products.js